<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false"
               top="3vh"
               width="1000px" v-if="formVisible">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <div class="tab-box" v-if="form.isMoreSpec === 1"><span :class="{'active': tabType}">基础信息</span><span :class="{'active': !tabType}">规格</span></div>
          <el-form ref="dataForm" :rules="formRules" :model="form"
                   label-position="right"
                   size="small" label-width="150px">
            <div v-show="tabType">
              <div class="title-box"><span class="txt1">商品基础信息</span></div>
              <el-form-item label="有无规格：" prop="isMoreSpec">
                <el-radio-group v-model="form.isMoreSpec" @input="inputMoreSpec">
                  <el-radio :label="1">有</el-radio>
                  <el-radio :label="0">无</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="聚水潭编码：" :prop="form.isMoreSpec === 1?'':'youCode'" key="1">
                <div style="display:flex">
                  <el-input v-model="form.youCode" placeholder="请输入聚水潭编码" :disabled="form.isMoreSpec === 1 || !!form.id" />
                  <el-button type="primary" @click="getyongyou" style="margin-left:5px" :disabled="form.isMoreSpec === 1 || !!form.id">获取数据</el-button>
                </div>
              </el-form-item>
              <el-form-item label="商品名称：" prop="name">
                <el-input v-model="form.name" placeholder="商品名称根据聚水潭编码自动读取" :disabled="!isGetYou && !form.isMoreSpec" />
              </el-form-item>
              <el-form-item label="曾用名：">
                <el-input v-model="form.aliasName" placeholder="请输入曾用名" />
              </el-form-item>
              <el-form-item label="商品分类：" prop="sysGoodsCategorizeList">
                <el-cascader v-model="form.sysGoodsCategorizeList" :options="categorizeOptions" :props="categorizepProps"
                             collapse-tags
                             clearable placeholder="请选择商品分类/护肤产品，唇膏系列"></el-cascader>
              </el-form-item>
              <el-form-item label="供应商：">
                <el-input v-model="form.supplier" placeholder="供应商根据聚水潭编码自动读取" :disabled="!isGetYou" />
              </el-form-item>
              <el-form-item label="虚拟销售量：" prop="virtualSalesCount">
                <el-input v-model="form.virtualSalesCount" placeholder="请输入虚拟销售量" />
              </el-form-item>
              <el-form-item label="起购数量：" prop="buyMinCount" v-if="!isIntegeal">
                <el-input v-model="form.buyMinCount" placeholder="请输入起购数量" />
              </el-form-item>
              <el-form-item label="预计预售发货时间：" prop="sendDay" v-if="!isIntegeal">
                <el-input v-model="form.sendDay" placeholder="请输入预售发货时间">
                  <i class="el-input__icon" slot="suffix">天</i>
                </el-input>
              </el-form-item>
              <template v-if="!form.isMoreSpec">
                <el-form-item :label="isIntegeal?'积分价':'零售价：'" prop="retailPrice">
                  <el-input v-model="form.retailPrice" :placeholder="isIntegeal?'请输入积分价':'根据聚水潭编码自动读取'" :disabled="!isGetYou && !isIntegeal" />
                </el-form-item>
                <el-form-item label="总库存：">
                  <el-input v-model="form.inventory" placeholder="根据聚水潭编码自动读取" :disabled="!isGetYou" />
                </el-form-item>
                <el-form-item label="税收分类编码：">
                  <el-input v-model="form.taxCode" placeholder="请输入税收分类编码" />
                </el-form-item>
                <!-- REQ-2026-234328 第一步：后台只留「产品规格」一个输入框，老的「商品规格」(spec) 下掉。
                     用户 2026-09-03 拍板两步走：本期**只收口 UI**，数据列和读方一律不动 ——
                     出库单、订单快照、开票的规格兜底现在都还在读 sys_goods.spec，
                     贸然停写会让这些地方拿到空值。下期再做存量迁移 + 读方切换。
                     ⚠️ 注意只删了输入框，`form.spec` 这个字段**故意留在 form 里**：
                     编辑时它由 fetchById 的返回整体覆盖进来，提交时原样带回去，
                     老值就不会因为"页面上看不见"而被清空。 -->
              </template>
              <!-- REQ-2026-234328 收尾（用户 2026-09-08 决定）：回收 product_spec，
                   规格只保留 sys_goods.spec 这一个字段。原先新增 product_spec 的唯一理由是
                   「优先从聚水潭同步、带来源标识」，但实测 spec_source 只有 EMPTY/MANUAL、
                   JUSHUITAN 零条，两个字段内容同维度（都是「15g/支」这类），属于纯重复。
                   出库单、订单快照、开票兜底本来就一直读 spec，收回来是最短路径。 -->
              <el-form-item label="商品规格：">
                <el-input v-model="form.spec" placeholder="请输入商品规格" maxlength="50" show-word-limit />
              </el-form-item>
              <el-form-item label="预计预售发货时间：" prop="sendDay" v-if="isIntegeal">
                <el-input v-model="form.sendDay" placeholder="请输入预售发货时间">
                  <i class="el-input__icon" slot="suffix">天</i>
                </el-input>
              </el-form-item>
              <el-form-item label="商品主图：" prop="img" class="width100">
                <div class="flexs">
                  <imageUpload v-model="form.img" width="32" height="32" />
                  <span class="hint hint1">限制上传1张<br />建议尺寸750x750像素以上</span>
                </div>
              </el-form-item>

              <el-form-item label="显示商城：" prop="sysGoodsAreaList" v-if="!isIntegeal">
                <el-checkbox-group v-model="form.sysGoodsAreaList" @change="syncPayModesWithMall(true)">
                  <el-checkbox v-for="area in mallAreaOptions" :key="area.id" :label="area.id">{{ area.name }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="商品banner图：" class="width100">
                <moreImageUpload v-model="form.bannerImg" :limit="10" hint-text="建议尺寸750x750像素以上" />
              </el-form-item>
              <el-form-item label="视频：" class="width100" v-if="!isIntegeal">
                <fileUpload v-model="form.video" hint-text="大小限制在50M以内" />
              </el-form-item>
              <el-form-item label="是否限制时间：" prop="isControlTime" key="2">
                <el-radio-group v-model="form.isControlTime">
                  <el-radio :label="0">不限制</el-radio>
                  <el-radio :label="1">限制</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="上下架时间：" prop="dateTime" v-if="form.isControlTime" key="3">
                <el-date-picker v-model="form.dateTime" size="small" type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
              <el-form-item label="是否限购：" prop="isQuota" key="4">
                <el-radio-group v-model="form.isQuota">
                  <el-radio :label="0">不限购</el-radio>
                  <el-radio :label="1">限购</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="限购数量：" prop="quotaNum" v-if="form.isQuota === 1" key="4">
                <el-input v-model="form.quotaNum" placeholder="请输入限购数量" />
              </el-form-item>
              <el-form-item label="单位：" prop="unit" v-if="!form.isMoreSpec">
                <!-- <el-input v-model="form.unit" placeholder="请输入单位" :disabled="!isGetYou" /> -->
                <el-input v-model="form.unit" placeholder="请输入单位" />
              </el-form-item>
              <el-form-item label="是否APP端展示：" prop="isShowApp">
                <el-radio-group v-model="form.isShowApp">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否开票：" prop="canInvoice">
                <el-radio-group v-model="form.canInvoice">
                  <el-radio :label="1">支持</el-radio>
                  <el-radio :label="0">不支持</el-radio>

                </el-radio-group>
              </el-form-item>
              <!-- REQ-2026-826259 商城活动规则：商品支持的支付方式，默认全选 -->
              <el-form-item label="支持的支付方式：" class="width100" prop="supportedPayModes">
                <el-checkbox-group v-model="supportedPayModeArr">
                  <el-checkbox v-for="item in payModeOptions" :key="item.key" :label="item.key"
                               :disabled="!isIntegeal && allowedPayModeKeys.length > 0 && allowedPayModeKeys.indexOf(item.key) < 0">
                    {{ item.value }}
                  </el-checkbox>
                </el-checkbox-group>
                <div class="pay-mode-tip">
                  <template v-if="!isIntegeal">
                    可勾选范围由上方「显示商城」决定：现金余额支付区可选现金、余额；零售价兑换专区可选零售价；学费赠送专区可选学费赠送。
                    每个已选商城至少勾一种对应的支付方式，否则商品在该商城不显示。<br />
                  </template>
                  <b>只勾「现金」时，该商品只支持现金购买，不能用余额、零售价、学费赠送购买</b>；
                  仅剩一种方式时 APP 只展示这一种。活动规则的支付模式必须在这里勾上，否则规则保存不了。
                </div>
              </el-form-item>
              <el-form-item label="余额不足允许现金补差：" class="width100">
                <el-radio-group v-model="form.allowCashTopUp">
                  <el-radio :label="true">允许</el-radio>
                  <el-radio :label="false">不允许</el-radio>
                </el-radio-group>
                <div class="pay-mode-tip">
                  客户用余额类账户支付但余额不够时，是否允许用现金补上差额。
                  补差不改变活动判定 —— 仍按客户选择的支付模式发赠品。
                </div>
              </el-form-item>
              <el-form-item label="商品标签：" class="width100" v-if="!isIntegeal">
                <el-input v-model="form.tag" placeholder="请输入标签" />
              </el-form-item>
              <el-form-item label="是否为礼包：" prop="isPackage">
                <el-radio-group v-model="form.isPackage">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- REQ-2026-826259 虚拟商品：勾上之后该商品的订单支付成功即自动完成、不走发货，
                   误勾实物商品会直接跳过发货，所以选「是」时必须二次确认（BUG-2026-604417） -->
              <el-form-item label="是否虚拟商品：" prop="isVirtual">
                <el-radio-group v-model="form.isVirtual" @change="onVirtualChange">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
                <span class="virtual-tip">虚拟商品的订单支付成功后自动完成，不发货</span>
              </el-form-item>
              <template v-if="form.isPackage === 1">
                <el-form-item label="正价商品：" class="width100" required>
                  <gift-vue :form="form" :type="1" :is-package="0"
                            :good-type="+isIntegeal?2:undefined"
                            :is-goods="1" @update-retail-price="updateRetailPrice" />
                  <div style="text-align: right;">合计：{{ giftAllTotalPrice }}</div>
                </el-form-item>
                <el-form-item label="赠品商品：" class="width100">
                  <gift-vue :form="form" :type="0" :is-package="0"
                            :good-type="+isIntegeal?2:undefined"
                            :is-goods="0" @update-retail-price="updateRetailPrice" />
                </el-form-item>
              </template>
              <!-- REQ-2026-470053 平台标签：APP商城的「平台新品」「平台爆款」筛选，积分商品不参与 -->
              <template v-if="!isIntegeal">
                <div class="title-box"><span class="txt1">平台标签</span><span class="txt2">用于APP商城的平台新品/平台爆款筛选，标签到期只影响筛选，不改变商品上下架状态</span></div>
                <el-form-item label="平台标签：" class="width100">
                  <el-checkbox-group v-model="platformTagCodeList" @change="handlePlatformTagChange">
                    <el-checkbox v-for="item in platformTagOptions" :key="item.key" :label="item.key">{{ item.value }}</el-checkbox>
                  </el-checkbox-group>
                  <div class="hint">商品首次上架时系统会自动打【平台新品】，默认 {{ platformTagDays }} 天；在这里手工勾选或调整有效期后来源会变成「人工」，取消勾选即为取消该标签。</div>
                </el-form-item>
                <!-- 只遍历 platformTagMap 里已经备好数据的标签，不要直接遍历 platformTagCodeList：
                     否则勾选瞬间 map 还没补上就会读 undefined.dateTime，整次渲染抛错、复选框跟着勾不上 -->
                <el-form-item v-for="code in platformTagEditableList" :key="'ptag-' + code"
                              :label="platformTagName(code) + '有效期：'" class="width100" required>
                  <el-date-picker v-model="platformTagMap[code].dateTime" size="small" type="datetimerange"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  start-placeholder="生效时间" end-placeholder="失效时间"></el-date-picker>
                  <span class="hint hint1">来源：{{ platformTagMap[code].sourceName || '人工' }}<template v-if="platformTagMap[code].operatedBy">（最后操作：{{ platformTagMap[code].operatedBy }} {{ platformTagMap[code].operatedTime }}）</template></span>
                </el-form-item>
                <!-- REQ-2026-470053：人工调整必须记录操作原因。
                     只在标签配置真的动过时才必填（见 verifyPlatformTags），
                     否则每次保存商品都要重填一遍原因，运营会被逼着乱填。

                     🔴 v-if 里的 platformTagChanged **一个都不能少**（BUG-2026-470053 #136）：
                     原来只判 platformTagCodeList.length，把标签**全部取消**时
                     长度为 0 → 输入框消失，而 verifyPlatformTags 发现指纹变了仍然报
                     「改动了平台标签，请填写操作原因」——**无处可填，整个商品存不下**。
                     “取消标签”恰恰是最需要写原因的那一步。 -->
                <el-form-item v-if="platformTagCodeList.length || platformTagChanged" label="操作原因：" class="width100">
                  <el-input v-model="platformTagReason" type="textarea" :rows="2" maxlength="200"
                            show-word-limit placeholder="改动平台标签时必填，例如：新品期延长至活动结束"></el-input>
                  <div class="hint">只在本次改动了平台标签（勾选或有效期）时必填；同一次保存里所有标签共用这一条原因。</div>
                </el-form-item>
                <el-form-item v-for="tag in platformTagHistory" :key="'ptag-his-' + tag.tagCode"
                              :label="tag.tagName + '：'" class="width100">
                  <span class="hint">{{ platformTagStatusText(tag) }}（{{ tag.effectiveAt }} ~ {{ tag.expiredAt }}，来源：{{ tag.sourceName }}），勾选上方可重新启用</span>
                </el-form-item>
              </template>
              <!-- 服务配置 -->
              <!-- <div class="title-box"><span class="txt1">服务配置</span><span class="txt2">根据系统默认配置的，默认读取</span><span class="fr" @click="addService">添加服务</span></div>
              <service-vue :form="form" :bisicsInfo="bisicsInfo" /> -->
              <div class="title-box"><span class="txt1">权限</span></div>
              <!-- 权限 -->
              <jurisd-vue :form="form" :bisics-info="bisicsInfo" :type="gType" />
              <template v-if="!isIntegeal">
                <div class="title-box"><span class="txt1">推荐商品</span></div>
                <recommend-goods-vue :form="form" />
              </template>

              <div class="title-box"><span class="txt1">商品详情</span></div>
              <el-form-item label="商品详情：" class="width100">
                <editor v-model="form.details" :min-height="240" :height="240" :upload-url="uploadUrl" />
              </el-form-item>
              <el-form-item label="商品资质：" class="width100" v-if="!isIntegeal">
                <editor v-model="form.qualification" :min-height="240" :height="240" :upload-url="uploadUrl" />
              </el-form-item>
              <el-form-item label="商品排序：" class="width100">
                <el-input v-model="form.sort" placeholder="请输入商品排序" />
                <span>系统自动带出排序，并支持修改</span>
              </el-form-item>
              <template v-if="!isIntegeal">
                <div class="title-box"><span class="txt1">分享朋友圈</span></div>
                <shareWX-vue :form="form" />
              </template>
              <el-form-item label="状态：" class="width100">
                <!-- 1 上架 2下架 -->
                <el-switch v-model="form.state" :active-value="1" :inactive-value="2"></el-switch>
              </el-form-item>
            </div>
            <div v-show="!tabType">
              <specs :form="form" :is-first-spec="isFirstSpec" :is-integeal="isIntegeal" />
            </div>
          </el-form>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" v-if="form.isMoreSpec && !tabType" @click="tabType = 1">上一步</el-button>
        <el-button type="primary" @click="doCreate()">{{ form.isMoreSpec && tabType?'下一步':'确定' }}</el-button>
      </div>
    </el-dialog>
    <!-- <basics-add ref="basicsAdd" @created="getBisicsInfo()" /> -->
  </div>
</template>

<script>

import sysGoodsApi from '@/api/goods/sysGoods'
import { MALL_AREA_OPTIONS, allowedPayModes, areasMissingPayMode } from './mallPayMode'
import sysGoodsShareApi from '@/api/goods/sysGoodsShare'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
import MoreImageUpload from "@/components/MoreImageUpload";
import FileUpload from "@/components/FileUpload"
import Editor from "@/components/Editor";
import Specs from '@/views/common/specs.vue'
import singleSpecsVue from '@/views/common/singleSpecs.vue';
import serviceVue from '@/views/common/service.vue';
import jurisdVue from '@/views/common/jurisd.vue';
import recommendGoodsVue from '@/views/common/recommendGoods.vue';
import shareWXVue from '@/views/common/shareWX.vue';
import basicsAdd from '../../config/basics/add.vue'
import sysGoodsPlatformTagApi from '@/api/goods/sysGoodsPlatformTag'
import { guid, Subtr, accMul, parseTime } from '@/utils/index'
import giftVue from '@/views/common/gift.vue'
function initFormBean() {
  const formBean = {
    youCode: '',
    isMoreSpec: 0, //规格类型  要改 1 有规格  0 无规格
    uuid: '',
    name: null,
    aliasName: '',
    sysGoodsCategorizeList: [], //商品分类  要改
    supplier: null, //供应商
    virtualSalesCount: null,
    buyMinCount: null,
    sendDay: null,
    img: null,
    sysGoodsAreaList: [3, 4, 5],
    bannerImg: [],
    video: [],
    isControlTime: '',
    dateTime: [],
    unit: '',
    tag: '',
    specData: [{ jushuitanCode: null, retailPrice: null, surplusStock: null, specDetail: null, aliasTitle: null, orderNo: null, specImg: null }],
    sysGoodsRecommendList: [],
    details: null,
    qualification: null,
    quotaNum: null,
    isQuota: '',
    shareData: {
      imgs: [],
      content: []
    },
    skuForm: [],
    retailPrice: '',
    isTopRecommend: 0,
    inventory: 0,
    isPackage: 0,
    isVirtual: 0,
    sysGoodsShareList: [],
    salesNum: 0,
    commissionType: 0,
    commissionAmount: 0,
    state: 2,
    isShowApp: 1,
    canInvoice: 0,
    isAuthsInternal: 0,
    giftData: [{ goodsId: '', specValuecombineId: '', num: '', price: '' }],
    giftData1: [{ goodsId: '', specValuecombineId: '', num: '', price: '' }],
    taxCode: '', // 税收分类编码
    spec: '', // 商品规格
    productSpec: '', // 产品规格 REQ-2026-234328
    specSource: 'EMPTY', // 产品规格来源 JUSHUITAN聚水潭 MANUAL人工 EMPTY未配置
    // REQ-2026-826259：支持的支付方式默认全选，允许现金补差
    supportedPayModes: 'CASH,BALANCE,XIAODUBI,GIFT',
    allowCashTopUp: true
  }
  return formBean
}

/**
 * 支付方式全集，与后端 ActivityRuleMatcher.ALL_PAY_MODES 一致，顺序也一致。
 * 四种，不是三种 —— 方案图的商品配置勾选里含「学费赠送」。
 */
const ALL_PAY_MODES = ['CASH', 'BALANCE', 'XIAODUBI', 'GIFT']

export default {
  components: { giftVue, Editor, ImageUpload, Treeselect, MoreImageUpload, FileUpload, Specs, singleSpecsVue, serviceVue, jurisdVue, recommendGoodsVue, shareWXVue, basicsAdd },
  props: ['categorizeOptions', 'isIntegeal'],
  data() {
    return {
      isGetYou: 0,
      categorizepProps: {
        label: 'name',
        value: 'id',
        children: 'child',
        multiple: true
      },
      uploadUrl: process.env.VUE_APP_BASE_API + '/sys/cosUploader/upload',
      form: initFormBean(),
      formVisible: false,
      formRules: {
        isMoreSpec: [{ required: true, message: '请选择规格类型', trigger: 'change' }],
        youCode: [{ required: true, message: '请输入聚水潭编码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        virtualSalesCount: [{ required: true, message: '请输入虚拟销售量', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        sendDay: [{ required: true, message: '请输入预售发货时间', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }],
        sysGoodsCategorizeList: [{ required: true, message: '请选择商品分类', trigger: 'change' }],
        img: [{ required: true, message: '请选择商品主图', trigger: 'change' }],
        sysGoodsAreaList: [{ required: true, message: '请选择显示商城', trigger: 'change' }],
        isControlTime: [{ required: true, message: '请选择是否限制时间', trigger: 'change' }],
        dateTime: [{ required: true, message: '请选择上下架时间', trigger: 'change' }],
        quotaNum: [{ required: true, message: '请输入限购数量', trigger: 'blur' },
          { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        isQuota: [{ required: true, message: '请选择是否限购', trigger: 'change' }],
        isShowApp: [{ required: true, message: '请选择是否APP端展示', trigger: 'change' }],
        canInvoice: [{ required: true, message: '请选择是否开票', trigger: 'change' }],
        specData: [{ required: true }],
        buyMinCount: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        isPackage: [{ required: true, message: '请选择是否为礼包', trigger: 'change' }],
        supportedPayModes: [{ required: true, message: '请至少勾选一种支付方式', trigger: 'change' }]
      },
      // REQ-2026-826259：支付方式选项。枚举与后端 ActivityPayMode 一致。
      // 原先是调 /payModeOptions 接口取，但那个 Controller 随方案重做已移除，
      // 四个枚举值本身不会变，直接写死即可，不必为此保留一个接口。
      mallAreaOptions: MALL_AREA_OPTIONS,
      payModeOptions: [
        { key: 'CASH', value: '现金' },
        { key: 'BALANCE', value: '余额' },
        { key: 'XIAODUBI', value: '零售价' },
        { key: 'GIFT', value: '学费赠送' }
      ],
      tabType: 1, //1 基础信息  0 规格
      bisicsInfo: null, //基本配置数据
      gType: 3, // //type 1 秒杀商品 2 积分商品 3普通商品
      packageData: '',
      isRepSub: false,
      isFirstSpec: 1,
      yongyouCode: '',
      isPostage: 1,
      actualQuantity: 1,
      giftAllTotalPrice: 0,
      // region REQ-2026-470053 平台标签
      // 标签不放进 form：form 会被 fetchById 的返回整体覆盖，
      // 而且提交时 form 是整体序列化的，标签要单独拼成 platformTagList
      platformTagOptions: [], // [{key:'NEW',value:'平台新品'}]
      platformTagDays: 7, // 自动新品默认天数，后端 sys_dataconstant 配的（2026-09-03 由 30 改为 7）
      platformTagCodeList: [], // 当前勾选的标签
      platformTagMap: {}, // tagCode -> { dateTime, sourceName, status, effective, operatedBy, operatedTime }
      platformTagReason: '', // 本次人工调整原因，同一次保存里所有标签共用
      // 进编辑页时的标签配置快照，用来判断本次到底动没动标签（决定原因是否必填）
      platformTagSnapshot: ''
      // endregion
    }
  },
  computed: {
    // BUG-2026-395890：显示商城决定哪些支付方式可勾
    allowedPayModeKeys() {
      return allowedPayModes(this.form.sysGoodsAreaList)
    },
    /**
     * 支付方式多选框的双向绑定（REQ-2026-826259）。
     *
     * 表单里存的是后端要的逗号串，多选框要的是数组，所以在这里转一层。
     * 值为空按<b>全选</b>解释 —— 存量商品这一列可能还没刷到，多选框默认全选，
     * 空值绝不能显示成「一种都不支持」。
     */
    supportedPayModeArr: {
      get() {
        const value = this.form.supportedPayModes
        if (value === undefined || value === null || value === '') {
          return ALL_PAY_MODES.slice()
        }
        return String(value).split(',').map(s => s.trim()).filter(s => s)
      },
      set(val) {
        this.$set(this.form, 'supportedPayModes', (val || []).join(','))
      }
    },

    /**
     * 本次是不是真的改动过平台标签。
     *
     * 模板（操作原因输入框是否渲染）、校验（是否必填）、拼参（传不传 reason）
     * **三处必须用同一个判据** —— #136 就是模板用 length、校验用指纹，两边对不上号卡死的。
     *
     * 依赖 platformTagCodeList 与 platformTagMap，两者都是响应式的，
     * 改勾选或改有效期都会重算。
     */
    platformTagChanged() {
      const fp = this.platformTagCodeList.slice().sort().map(code => {
        const range = (this.platformTagMap[code] || {}).dateTime || []
        return code + '|' + (range[0] || '') + '|' + (range[1] || '')
      }).join(';')
      return fp !== this.platformTagSnapshot
    },
    /**
     * 已取消/已过期且这次没勾选的标签，只读展示一行历史，方便运营看到来源和上次有效期
     */
    platformTagHistory() {
      const list = (this.form && this.form.platformTagList) || []
      return list.filter(tag => tag.status !== 1 && this.platformTagCodeList.indexOf(tag.tagCode) < 0)
    },
    /**
     * 勾选中、且 platformTagMap 里已经有数据的标签，用来渲染「有效期」行
     */
    platformTagEditableList() {
      return this.platformTagCodeList.filter(code => !!this.platformTagMap[code])
    }
  },
  watch: {
    /**
     * 勾选变化后立刻补齐 platformTagMap（REQ-2026-470053 集成测试 F-1）
     *
     * el-checkbox 是先同步改 v-model、再在 $nextTick 里 dispatch group 的 change 事件，
     * 而模板渲染排在这两者中间；只靠 @change 里的 ensurePlatformTag 补 map 太晚，
     * 没打过该标签的商品（map 里没这个 key）首次勾选必然渲染报错 reading 'dateTime'。
     * watch 的回调在 Vue2 调度里排在渲染 watcher 之前，能赶在渲染前把默认有效期填好。
     */
    platformTagCodeList: {
      immediate: true,
      handler(codes) {
        (codes || []).forEach(code => this.ensurePlatformTag(code))
      }
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    this.getBisicsInfo()
    if (!this.isIntegeal) this.getPlatformTagConfig()
  },

  methods: {
    // region REQ-2026-470053 平台标签
    getPlatformTagConfig() {
      sysGoodsPlatformTagApi.options().then(({ data }) => {
        this.platformTagOptions = data || []
      })
      sysGoodsPlatformTagApi.newTagDays().then(({ data }) => {
        if (data > 0) this.platformTagDays = data
      })
    },
    platformTagName(code) {
      const find = this.platformTagOptions.find(item => item.key === code)
      if (find) return find.value
      return code === 'HOT' ? '平台爆款' : '平台新品'
    },
    platformTagStatusText(tag) {
      if (tag.status === 0) return '已取消'
      if (tag.status === 2) return '已过期'
      return tag.effective ? '生效中' : '未生效'
    },
    /**
     * 新勾选一个标签时给的默认有效期：现在起 N 天，N 取后端的自动新品天数配置
     */
    defaultPlatformTagRange() {
      const start = new Date()
      const end = new Date(start.getTime() + this.platformTagDays * 24 * 60 * 60 * 1000)
      return [parseTime(start), parseTime(end)]
    },
    ensurePlatformTag(code) {
      const item = this.platformTagMap[code]
      if (!item) {
        this.$set(this.platformTagMap, code, {
          dateTime: this.defaultPlatformTagRange(),
          sourceName: '',
          status: null,
          effective: false,
          operatedBy: '',
          operatedTime: ''
        })
      } else if (!item.dateTime || item.dateTime.length < 2) {
        this.$set(item, 'dateTime', this.defaultPlatformTagRange())
      }
    },
    handlePlatformTagChange(codes) {
      (codes || []).forEach(code => this.ensurePlatformTag(code))
    },
    /**
     * 编辑时回填标签。status=1 的算「当前配置着的」默认勾上，
     * 已取消(0)/已过期(2)的不勾，但保留它们的有效期和来源，重新勾上时不用再填一遍
     */
    calcPlatformTagData() {
      const tagList = (this.form && this.form.platformTagList) || []
      const codes = []
      tagList.forEach(tag => {
        this.$set(this.platformTagMap, tag.tagCode, {
          dateTime: tag.effectiveAt && tag.expiredAt ? [tag.effectiveAt, tag.expiredAt] : this.defaultPlatformTagRange(),
          sourceName: tag.sourceName,
          status: tag.status,
          effective: tag.effective,
          operatedBy: tag.operatedBy,
          operatedTime: tag.operatedTime
        })
        if (tag.status === 1) codes.push(tag.tagCode)
      })
      this.platformTagCodeList = codes
      this.platformTagReason = ''
      // 快照必须在 platformTagCodeList 赋值之后取，否则拿到的是上一个商品的配置
      this.$nextTick(() => {
        this.platformTagSnapshot = this.platformTagFingerprint()
      })
    },
    /**
     * 把当前的标签配置压成一个可比较的字符串：勾了哪些标签 + 各自的有效期。
     * 用它和进页面时的快照比，判断本次保存有没有真的改动标签。
     *
     * ⚠️ 模板里不要直接调它，走 computed 的 platformTagChanged：
     * 模板里调方法每次重渲染都重算，而且**不会因为 platformTagMap 变了就重渲染** ——
     * 只改有效期（不动勾选）时输入框会不出来。
     */
    platformTagFingerprint() {
      return this.platformTagCodeList.slice().sort().map(code => {
        const range = (this.platformTagMap[code] || {}).dateTime || []
        return code + '|' + (range[0] || '') + '|' + (range[1] || '')
      }).join(';')
    },
    /**
     * 保存前校验：勾了的标签必须有完整的有效期，且生效时间早于失效时间
     *
     * @return 出错信息，空串表示通过
     */
    verifyPlatformTags() {
      for (let i = 0; i < this.platformTagCodeList.length; i++) {
        const code = this.platformTagCodeList[i]
        const range = (this.platformTagMap[code] || {}).dateTime || []
        if (!range[0] || !range[1]) return '请设置【' + this.platformTagName(code) + '】的生效时间和失效时间'
        // value-format 是 yyyy-MM-dd HH:mm:ss，定长字符串直接比大小就是比时间
        if (range[0] >= range[1]) return '【' + this.platformTagName(code) + '】的生效时间必须早于失效时间'
      }
      // 只有本次真的动过标签才要求填原因。新增商品没有快照（空串），
      // 勾了标签就算动过，同样要填。
      if (this.platformTagChanged && !(this.platformTagReason || '').trim()) {
        return '改动了平台标签，请填写操作原因'
      }
      return ''
    },
    buildPlatformTagList() {
      // 只有本次真的改动过标签才传 reason。没改动就整条不传（后端按 null = 不动原因处理），
      // 否则点一次「保存商品」就会把之前记的原因抹成空 —— 商品页每次保存都会把全部标签重提一遍。
      const changed = this.platformTagChanged
      const reason = (this.platformTagReason || '').trim()
      return this.platformTagCodeList.map(code => {
        const range = (this.platformTagMap[code] || {}).dateTime || []
        const item = { tagCode: code, effectiveAt: range[0], expiredAt: range[1] }
        if (changed) item.reason = reason
        return item
      })
    },
    // endregion

    // region REQ-2026-826259 商城活动规则
    // endregion
    updateRetailPrice() {
      const { isPackage, giftData, isMoreSpec } = this.form
      // 计算正价商品的总价
      if (isPackage === 1) {
        let totalPrice = 0
        giftData && giftData.forEach(item => {
          if (item.price) {
            totalPrice = Subtr(totalPrice, -accMul(item.num, item.price))
          }
        })
        if (!isMoreSpec) {
          this.form.retailPrice = totalPrice;
        }
        this.giftAllTotalPrice = totalPrice
        this.$forceUpdate()
      }
    },
    // REQ-2026-234328 手动修改产品规格时同步来源标识
    //获取用友商品数据
    getyongyou() {
      const { youCode } = this.form;
      if (!youCode) return this.$message.error('请输入聚水潭编码')
      sysGoodsApi.getGoodsByYongYouCode({ codes: youCode }).then(res => {
        if (res.code === '0') {
          const datas = res.data ? JSON.parse(res.data) : [];
          this.form.name = datas.length > 0 ? datas[0].name : ''
          this.form.supplier = datas.length > 0 ? datas[0].supplier_name : ''
          if (!this.isIntegeal) this.form.retailPrice = datas.length > 0 ? datas[0].sale_price : ''
          this.form.unit = datas.length > 0 ? datas[0].unit : '';
          // REQ-2026-234328 产品规格：聚水潭有值自动带入并标识来源，无值保留人工填写
          const jstSpec = datas.length > 0 && datas[0].properties_value ? String(datas[0].properties_value).trim() : ''
          if (jstSpec) {
            // 能力保留，只是写回 spec；不再记 specSource —— 那套来源标识随 product_spec 一起回收
            this.form.spec = jstSpec.slice(0, 50)
          }
          this.isGetYou = 1;
          this.actualQuantity = (datas.length > 0 && datas[0].items) ? this.getTotalQty(datas) : 1;
        }
      })
      sysGoodsApi.getGoodsQuantityByYongYouCode({ codes: youCode }).then(res => {
        if (res.code === '0') {
          const arr1 = res.data ? res.data : []
          this.form.inventory = arr1.length > 0 ? +arr1[0].qty : 0
        }
      })
    },
    getTotalQty(datas) {
      let totalQty = 0;
      // 遍历 datas 数组
      for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        // 检查 data 中是否存在 items 属性
        if (data.items) {
          // 遍历 items 数组
          for (let j = 0; j < data.items.length; j++) {
            const item = data.items[j];
            // 检查 item 中是否存在 qty 属性
            if (item.qty) {
              totalQty += item.qty;
            }
          }
        }
      }
      return totalQty;
    },

    getBisicsInfo() {
      sysDataconstantApi.fetchBatchCode({ code: 'product_seckill_buy_auth,product_point_buy_auth,product_buy_auth,product_seckill_price_auth,product_point_price_auth,product_price_auth' }).then(({ data }) => {
        data.list.forEach(item => {
          item.content2 = item.content2 ? JSON.parse(item.content2) : ''
        });
        this.bisicsInfo = data.list
      })
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.child && !node.child.length) {
        delete node.child;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isFirstSpec = 1
      this.tabType = 1
      this.form = initFormBean()
      this.platformTagCodeList = []
      this.platformTagMap = {}
    },
    /**
     * 打开新建表单
     */
    handleCreate(total, type) {
      this.resetForm()
      this.form.sort = total + 1
      this.gType = type || 3
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row, type) {
      this.resetForm()
      this.gType = type || 3
      sysGoodsApi.fetchById(row.id).then((response) => {
        if (!response || !response.data) {
          this.$message.error('获取商品数据失败，请重试')
          return
        }
        const data = response.data
        this.form = data;
        this.calcEditData()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch((error) => {
        console.error('获取商品详情失败:', error)
        this.$message.error('获取商品数据失败，请重试')
      })
    },
    /**
     * BUG-2026-395890：支付方式只保留显示商城允许的。
     * addForNewMall=true 用于用户勾选商城：新勾上的商城若一种对应方式都没勾，自动勾上它的全部方式，
     * 免得运营还要再去下面补勾；进编辑页时只收口不补勾，不替运营改意图。
     */
    syncPayModesWithMall(addForNewMall) {
      const allowed = allowedPayModes(this.form.sysGoodsAreaList)
      // 还没选商城时不收窄：收成空值会被当成「全选」，与后端「没选这三个商城不收窄」一致
      if (!allowed.length) return
      let modes = this.supportedPayModeArr.filter(mode => allowed.indexOf(mode) > -1)
      if (addForNewMall) {
        areasMissingPayMode(this.form.sysGoodsAreaList, modes).forEach(area => { modes = modes.concat(area.payModes) })
      }
      const ordered = ALL_PAY_MODES.filter(mode => modes.indexOf(mode) > -1)
      if (ordered.join(',') !== this.supportedPayModeArr.join(',')) this.supportedPayModeArr = ordered
    },
    inputMoreSpec() {
      if (this.form.isMoreSpec) {
        this.$set(this.form, 'youCode', '');
      } else {
        if (this.form.id) this.$set(this.form, 'youCode', this.yongyouCode);
      }
    },
    calcEditData() {
      const { sysGoodsSpecValuecombineList, sysGoodsCategorizeList, listingStartTime, listingEndTime, bannerImg, video, isMoreSpec, sysGoodsPackageConfigShowList } = this.form;
      // REQ-2026-826259：存量商品这两列可能是 NULL（增量脚本没刷到），
      // 按「全选 + 允许补差」兜底，和后端 normalizePayModes 的口径一致
      if (!this.form.supportedPayModes) {
        this.$set(this.form, 'supportedPayModes', ALL_PAY_MODES.join(','))
      }
      // BUG-2026-395890：存量商品可能勾了所在商城用不上的支付方式（生产 78 个），进编辑页即收口，与后端保存时一致
      if (!this.isIntegeal) this.syncPayModesWithMall(false)
      if (this.form.allowCashTopUp === null || this.form.allowCashTopUp === undefined) {
        this.$set(this.form, 'allowCashTopUp', true)
      }
      //有无规格
      // this.$set(this.form, 'isMoreSpec', sysGoodsSpecValuecombineList.length > 1 ? 1 : 0);
      //商品分类
      const categArr = []
      const categorizeList = this.treeToList2(this.categorizeOptions)
      sysGoodsCategorizeList && sysGoodsCategorizeList.forEach(item => {
        const find = categorizeList.find(it => it.id === item);
        if (find && find.parentid) {
          categArr.push([find.parentid, find.id])
        } else {
          if (find) categArr.push([find.id])
        }
      })
      this.$set(this.form, 'sysGoodsCategorizeList', categArr);
      //上下架时间
      if (listingStartTime && listingEndTime) this.$set(this.form, 'dateTime', [listingStartTime, listingEndTime]);
      else this.$set(this.form, 'dateTime', []);
      //banner图
      this.$set(this.form, 'bannerImg', this.clacArrObj(bannerImg));
      //视频
      this.$set(this.form, 'video', this.clacArrObj(video));
      //朋友圈
      this.$set(this.form, 'shareData', { imgs: [], content: [] });

      //无规格的时候
      if (!isMoreSpec) {
        this.$set(this.form, 'retailPrice', sysGoodsSpecValuecombineList[0].retailPrice);
        this.$set(this.form, 'youCode', sysGoodsSpecValuecombineList[0].jushuitanCode);
        this.yongyouCode = sysGoodsSpecValuecombineList[0].jushuitanCode
        this.isFirstSpec = 0
      }
      //正价商品 赠品商品
      if (sysGoodsPackageConfigShowList.length > 0) {
        this.$set(this.form, 'isPackage', 1)
      }
      const arr = []; const arr1 = []
      sysGoodsPackageConfigShowList.forEach(item => {
        if (item.isGift) arr.push(item)
        else arr1.push(item)
      })
      this.$set(this.form, 'giftData1', arr.length > 0 ? arr : [{ goodsId: '', specValuecombineId: '', num: '', price: '' }]);
      this.$set(this.form, 'giftData', arr1.length > 0 ? arr1 : [{ goodsId: '', specValuecombineId: '', num: '', price: '' }]);
      //平台标签
      this.calcPlatformTagData()
    },

    clacArrObj(str) {
      if (!str) return []
      const arr = str.split(',')
      const newArr = []
      arr.forEach((item, index) => {
        newArr.push({ url: item, uid: 'a_' + index })
      })
      return newArr
    },
    treeToList2(tree) {
      let node; const result = tree.map(node => (node.level = 1, node))
      for (let i = 0; i < result.length; i++) {
        if (!result[i].child) continue
        const list = result[i].child.map(node => (node.level = result[i].level + 1, node))
        result.splice(i + 1, 0, ...list)
      }
      return result
    },
    calcJurisd(forArr) {
      const arr = []
      forArr.forEach(item => {
        if (item.isActive) arr.push(item.key)
      })
      return arr
    },
    calcParams() {
      const params = JSON.parse(JSON.stringify(this.form))
      console.log(params)
      params.listingStartTime = params.dateTime[0]
      params.listingEndTime = params.dateTime[1]
      delete params.dateTime
      params.customerLevelBuyList = this.calcJurisd(params.customerLevelBuyList)
      params.customerLevelList = this.calcJurisd(params.customerLevelList)
      params.sysRoleList = this.calcJurisd(params.sysRoleList)
      params.technicalServiceLevelList = this.calcJurisd(params.technicalServiceLevelList)
      params.giftData.forEach(obj => {
        obj.isGift = 0; obj.num = +obj.num; obj.price = +obj.price || 0; delete obj.specArr;
      })
      params.giftData1.forEach(obj => { obj.isGift = 1; obj.num = +obj.num; obj.price = 0; delete obj.specArr })
      if (params.isPackage === 1) {
        const allGiftData = params.giftData.concat(params.giftData1)
        const validGiftData = allGiftData.filter(item => item.goodsId && item.specValuecombineId && item.num)
        params.packageData = JSON.stringify(validGiftData)
      }
      // REQ-2026-470053 平台标签：积分商品不参与，删掉字段（后端把 null 当成「本次不动标签」）；
      // 普通商品一律按页面勾选覆盖，全不勾就是清空
      if (this.isIntegeal) {
        delete params.platformTagList
        delete params.platformTagReason
      } else {
        params.platformTagList = this.buildPlatformTagList()
        // 🔴 原因要**单独再传一份**（BUG-2026-470053 #148a）。
        //    buildPlatformTagList() 只遍历勾中的标签，**被取消的那个不在里面** ——
        //    后端是拿“库里有、提交里没”算出取消的，永远取不到它的 reason。
        //    把标签全部取消时 platformTagList 是空数组，更是只剩这条。
        if (this.platformTagChanged) params.platformTagReason = (this.platformTagReason || '').trim()
      }
      return params
    },
    // 选「是虚拟商品」要二次确认：勾上之后该商品的订单支付成功即自动完成、不发货，
    // 误勾到实物商品会让订单直接跳过发货环节。取消就退回「否」。
    // 「限该商品无在途订单时才可改」的口径产品还没答复，先只做二次确认。
    onVirtualChange(val) {
      if (val !== 1) return
      this.$confirm('勾选后该商品订单支付成功即自动完成、不发货，确认该商品为虚拟商品？', '请确认', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => {
        this.$set(this.form, 'isVirtual', 0)
      })
    },
    calcStock(list) {
      let count = 0;
      if (!list.length) return 0
      list.forEach(item => {
        if (item.surplusStock) count = Subtr(count, -item.surplusStock)
      })
      count = +count
      return count
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid, invalidFields) => {
        if (!valid) console.log(invalidFields)
        if (valid) {
          const { isMoreSpec, isPackage, giftData, giftData1 } = this.form
          // 平台标签的时间校验放在切规格页之前，报错时用户还停在基础信息页上能直接改
          if (!this.isIntegeal) {
            const tagError = this.verifyPlatformTags()
            if (tagError) return this.$message.error(tagError)
            const missing = areasMissingPayMode(this.form.sysGoodsAreaList, this.supportedPayModeArr)
            if (missing.length) return this.$message.error(`【${missing.map(a => a.name).join('、')}】至少勾选一种对应的支付方式，否则商品在该商城不显示`)
          }
          if (isMoreSpec && this.tabType) return this.tabType = 0
          if (isPackage === 1) {
            const validGiftData = giftData.filter(item => item.goodsId && item.specValuecombineId && item.num)
            if (validGiftData.length === 0) return this.$message.error('请至少添加一个完整的正价商品')
            const hasGoodsIdGiftData1 = giftData1.filter(item => item.goodsId)
            const validGiftData1 = hasGoodsIdGiftData1.filter(item => item.specValuecombineId && item.num)
            if (hasGoodsIdGiftData1.length > 0 && validGiftData1.length === 0) return this.$message.error('请完整填写赠品商品信息')
          }
          const params = this.calcParams()
          if (!params.customerLevelBuyList.length) return this.$message.error('请选择购买权限')
          if (!params.customerLevelList.length && !params.sysRoleList.length && !params.technicalServiceLevelList.length) return this.$message.error('请选择查看权限')
          if (isMoreSpec) {
            if (!params.skuList || (params.skuList && !params.skuList.length)) return this.$message.error('请配置商品规格')
            params.skuList.forEach(item => { delete item.specList })
            params.specData = JSON.stringify(params.skuList)
            params.inventory = this.calcStock(params.skuList)
          } else {
            ///jushuitanCode  聚水潭编码
            const specId = params.id ? params.specList[0].valueList[0].id : ''
            const actualQuantity = params.id ? params.sysGoodsSpecValuecombineList[0].actualQuantity : this.actualQuantity;
            const id = params.id ? params.sysGoodsSpecValuecombineList[0].id : 0
            // BUG-2026-486203：编辑态保住既有 alias_title，别无条件写成商品名。
            // 同一段里 specId / actualQuantity / id 三个都写了 `params.id ? 取既有值 : 默认`，
            // 唯独 aliasTitle 直接写 params.name —— 每保存一次商品，单规格 SKU 的别名就被覆盖成商品名
            // （在售商品里 25 条 alias_title 因此和名字一样）。既有值为 null 才回落商品名（老数据/新建）。
            const existAliasTitle = params.id ? params.sysGoodsSpecValuecombineList[0].aliasTitle : undefined
            const aliasTitle = existAliasTitle != null ? existAliasTitle : params.name
            params.specData = JSON.stringify([{ actualQuantity, id, jushuitanCode: params.youCode, retailPrice: params.retailPrice || 0, surplusStock: params.inventory, specDetail: specId, aliasTitle, orderNo: 0, specImg: params.img }])
          }

          params.sysGoodsCategorizeList = params.sysGoodsCategorizeList.length ? params.sysGoodsCategorizeList.map(subArray => subArray[subArray.length - 1]) : [];
          params.bannerImg = params.bannerImg.length ? params.bannerImg.map(banner => banner.url).toString() : ''
          params.video = params.video.length ? params.video.map(video => video.name).toString() : ''
          // console.log(params)
          // return
          if (this.isIntegeal) {
            params.sysGoodsAreaList = [2]
            this.submitGoods(params)
          } else {
            this.submitShareWX(params)
          }
        }
      });
    },
    submitShareWX(params) {
      const { imgs, content } = params.shareData;
      if (imgs.length > 0 || content.length > 0) {
        sysGoodsShareApi.create({ content: JSON.stringify(content), imgs: JSON.stringify(imgs) }).then(res => {
          params.sysGoodsShareList = [res.data.id]
          this.submitGoods(params)
        })
      } else {
        // 编辑时必须显式提交空数组，后端才会清除原有分享关系。
        // 否则 params 会保留详情接口返回的旧分享 ID，导致最后一张图删除后再次出现。
        params.sysGoodsShareList = []
        this.submitGoods(params)
      }
    },
    submitGoods(params) {
      delete params.shareData
      delete params.skuForm
      delete params.skuList
      delete params.sysGoodsSpecValuecombineList
      delete params.giftData
      delete params.giftData1
      params.virtualSalesCount = +params.virtualSalesCount || ''
      params.buyMinCount = +params.buyMinCount || 1
      params.quotaNum = +params.quotaNum || 0
      params.sort = +params.sort || ''
      params.inventory = +params.inventory || 0
      params.isPostage = 1;
      if (this.isRepSub) return
      this.isRepSub = true
      if (params.id > 0) {
        sysGoodsApi.update(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      } else {
        if (!this.form.isMoreSpec) params.uuid = guid()
        sysGoodsApi.create(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      }
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    }
    //添加服务
    // addService() {
    //   let find = this.bisicsInfo.find(item => item.code === 'goods_services')
    //   this.$refs.basicsAdd.handleUpdate(find)
    // }
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  padding-bottom: 40px;
  // padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}
.table-list {
  border: 1px solid #e4e4e4;

  .sp-col {
    flex: 1;
    color: #666;
    height: 40px;
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;

    &.flex2 {
      // flex-grow: 3;
    }
    ::v-deep .el-form-item__error {
      font-size: 10px;
      right: 0;
      top: 24px;
      text-align: center;
    }

    &:last-child {
      border-right: 0;
    }

    &.enter-param {
      flex: 5;
    }
  }

  .spec-head {
    display: flex;
    font-size: 14px;
    align-items: center;
    background-color: #f9fafc;

    label {
      color: #ff4949;
    }
  }

  .spec-item {
    display: flex;
    font-size: 12px;
    align-items: center;
    border-top: 1px solid #e4e4e4;
    .sp-col {
      .el-input {
        ::v-deep .el-input__inner {
          border: none;
          text-align: center;
        }
      }

      .el-button {
        font-size: 12px;
      }
    }
  }
}
.item-flex {
  display: flex;
  margin-bottom: 5px;
  .icon-box {
    display: inline-block;
    width: 60px;
    i {
      font-size: 20px;
      margin-left: 5px;
      cursor: pointer;
      font-weight: bold;
      color: #465c99;
    }
  }
}
.oper-icon {
  i {
    font-size: 16px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: bold;
    color: #465c99;
  }
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.hint {
  font-size: 12px;
  color: #878787;
  &.hint1 {
    padding-left: 10px;
    line-height: 18px;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-left: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
/* REQ-2026-826259 支付方式说明文案 */
.pay-mode-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}

.virtual-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 12px;
}
</style>
